<router-outlet></router-outlet>
<app-update-notification />
<dk-cookie-consent />
